// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"97766530","228":"8f4f6825","569":"664eb6a1","936":"8621e9f1","959":"18ef85bb"}[chunkId] + ".chunk.js";
};